namespace Seac.Pages {
	export class PageUtility {
		private static _isHiddenByResize: boolean = false;
		/** Identificativo della classe dell'overlay che viene mostrato nel caso in cui la risoluzione dello schermo non sia supportata per la pagina */
		private static _resolutionOverlayClass: string = 'resolution-overlay';
		/** Identificativo del pulsante che rimuove l'overlay che viene mostrato nel caso in cui la risoluzione dello schermo non sia supportata per la pagina */
		private static _removeOverlayButtonId: string = 'remove-overlay-button';
		/** Dimensione minima in pixel per la visualizzazione automatica del menu */
		public minWidthToViewMenu: number = 1280

		/** Metodo che ritorna se l'applicazione è in esecuzione su un mobile device */
		public static get isMobileDevice(): boolean {
			return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		}

		constructor() {
			// Imposto il comportamento di default per i componenti DevExpress
			// questo comportamento può essere sovrascritto dal singolo componente
			DevExpress.ui.dxNumberBox.defaultOptions({
				options: {
					// Imposto tutte le input numeric in modo che al focus venga selezionato tutto il testo
					onFocusIn: (event: Seac.Commons.DxEvents.DxNumberBoxFocusInEvent) => {
						$(event.element).find('input.dx-texteditor-input').select();
					},
					// Imposto la classe in modo che il testo venga sempre allineato a destra
					inputAttr: {
						 'class' : 'text-right' 
					}
				}
			});

			DevExpress.ui.dxDateBox.defaultOptions({
				options: {
					// Imposto tutte le input date in modo che al focus venga selezionato tutto il testo
					onFocusIn: (event: Seac.Commons.DxEvents.DxNumberBoxValueChangeEvent) => {
						$(event.element).find('input.dx-texteditor-input').select();
					},
					displayFormat: Seac.Resources.Common.data_formato_GMA
				}
			});

			DevExpress.ui.dxSelectBox.defaultOptions({
				options: {
					// Imposto tutte le input selectbox in modo che al focus venga selezionato tutto il testo
					onFocusIn: (event: Seac.Commons.DxEvents.DxNumberBoxValueChangeEvent) => {
						$(event.element).find('input.dx-texteditor-input').select();
					},
					// Imposto il filtro su tutti i componenti selectBox
					searchEnabled: true,
					searchTimeout: 0
				}
			});

			DevExpress.ui.dxDropDownBox.defaultOptions({
				options: {
					// Imposto tutte le input dropdownbox in modo che al focus venga selezionato tutto il testo
					onFocusIn: (event: Seac.Commons.DxEvents.DxNumberBoxValueChangeEvent) => {
						$(event.element).find('input.dx-texteditor-input').select();
					}
				}
			});

			DevExpress.ui.dxDataGrid.defaultOptions({
				options: {
					// Nel caso sia un dispositovo mobile abilito l'hiding delle colonne
					columnHidingEnabled		: Seac.Pages.PageUtility.isMobileDevice,
					// Abilito il resize delle colonne solo se non sono su un dispositivo mobile
					allowColumnResizing		: !Seac.Pages.PageUtility.isMobileDevice,
					columnResizingMode		: 'nextColumn',
					// Imposto alcune altre proprietà che sono uguali per tutte le griglie
					showBorders				: true,
					rowAlternationEnabled	: true,
					keyboardNavigation		: {
						enabled				: false
					}
				}
			});
		}

		/**
		 * Metodo che viene richiamato nelle colonne delle griglie `Seac.PTAZ.Helpers.DxComponents.DxGridExtensions.cs` per abilitare l'hiding delle colonne in base al device su cui è in esecuzione l'applicazione
		 * @param priority Priorità con cui la colonna viene nascosta
		 */
		public static hidingPriority(priority: number): number {
			return Seac.Pages.PageUtility.isMobileDevice ? priority : undefined;
		}

		/** Metodo che si occupa di nascondere il menu nel caso la pagina risulti essere troppo stretta */
		public static hideMenuOnSmallPage(): void {
			const minWidthToViewMenu: number = Seac.Pages.pageUtility && Seac.Pages.pageUtility.minWidthToViewMenu
				? Seac.Pages.pageUtility.minWidthToViewMenu
				: 1280
			;
			// 18.75 è la larghezza del menu in rem (300 px) impostata dal css, attenzione se viene modificata (_variables.scss)
			const leftMenuWidth: number = this._convertRemToPixels(18.75);
			const hideMenuBreakpoint: number = minWidthToViewMenu - leftMenuWidth - (this._convertRemToPixels(2.188) * 2);
			// Ricavo la larghezza dell'app-container compreso padding e margin
			const appContainerWidth: number = $(`#${Seac.Commons.Constants.appContainerId}`).width();
			// Devo applicare un timeout, perché al "primo giro" leftMenuComponent non è ancora inizializzato
			setTimeout(() => {
				// Utilizzo ElvisOperator perché nel caso della visualizzazione da mobile app il leftMenuComponent non è definito
				if (Seac.Components.leftMenuComponent?.isOpened()) {
					if (appContainerWidth < hideMenuBreakpoint) {
						// Se il menu è aperto e la largehezza dell'app-container è minore di `hideMenuBreakpoint`
						// Nascondo il menu e applico lo stile in modo che il menu appaia sopra al contenuto quando aperto
						Seac.Components.leftMenuComponent.hideMenu();
						$(`#${Seac.Commons.Constants.appContainerId}`).addClass('small-page');
						this._isHiddenByResize = true;
					} 
				}else {
					if (appContainerWidth - leftMenuWidth > hideMenuBreakpoint) {
						// Se il menu è chiuso, ma la larghezza dell'app-container + la larghezza del menu superano i `hideMenuBreakpoint`
						// rimuovo lo stile che mostrerebbe il menu sopra il contenuto e se il menu è stato chiuso in seguito ad un resize lo riapro
						$(`#${Seac.Commons.Constants.appContainerId}`).removeClass('small-page');
						if (this._isHiddenByResize) {
							Seac.Components.leftMenuComponent.showMenu();
						}
					}else {
						// Altrimenti iposto solamente lo stile in modo che il menu appaia sopra al contenuto
						$(`#${Seac.Commons.Constants.appContainerId}`).addClass('small-page');
					}
				}
			}, 0);
		}

		/**
		 * Converte da un valore rem a px
		 * @param rem valore rem (solo numerico)
		 */
		private static _convertRemToPixels(rem: number) {
			return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
		}

		/**
		 * Estrae il valore di un query param dall'URL della pagina
		 * @param queryParamName Nome del parametro da estrarre
		 */
		public static getQueryParamValue(queryParamName: string): string {
			const queryParams: string = window.location.search.substring(1);
			const splittedQueryParams : Array<string> = queryParams.split('&');

			for (let paramIndex = 0; paramIndex < splittedQueryParams.length; paramIndex++) {
				const splittedParam: Array<string> = splittedQueryParams[paramIndex].split('=');

				if (splittedParam[0] === queryParamName) {
					let queryParamValue: string = '';
					// Nel caso in cui il valore contenesse un uguale e non fosse codificato sarebbe splittato in più stringhe,
					// quindi faccio il merge in una stringa sola
					for (let splitteParamIndex = 1; splitteParamIndex < splittedParam.length; splitteParamIndex++) {
						if (queryParamValue) {
							// Riaggiungo l'uguale che era stato tolto dallo split
							queryParamValue+= '=';
						}
						queryParamValue += splittedParam[splitteParamIndex];
					}
					return decodeURIComponent(queryParamValue);
				}
			}
		};

		/**
		 * Mostra un overlay sopra la pagina nel caso in cui la risoluzione dello schermo non sia supportata dalla pagina
		 * @param resolutionOverlayType Tipo di overlay da mostrare (Ruota dispositivo oppure pagina no supportata)
		 */
		public static showResolutionOverlay(resolutionOverlayType: ResolutionOverlayType): void {
			let resolutionIcon: string = resolutionOverlayType === ResolutionOverlayType.RotateDevice ? 'fa-sync' : 'fa-eye-slash';
			let resolutionMessage: string = resolutionOverlayType === ResolutionOverlayType.RotateDevice ? Resources.Common.ruotare_dispositivo_per_visualizzare_pagina : Resources.Common.risoluzione_non_supportata_pagina;
			
			if ($(`.${this._resolutionOverlayClass}.overlay-${resolutionIcon}`).length) {
				// Se l'overlay è già presente esco senza fare nulla
				return;
			}else if ($(`.${this._resolutionOverlayClass}`).length) {
				// Se è presente un'altro tipo di overlay lo nascondo
				this.removeResolutionOverlay();
			}
			let overlayContent: string = 
`<div class="${this._resolutionOverlayClass} overlay-${resolutionIcon}">` +
	`<div class="centered-container">` +
		`<i class="fas ${resolutionIcon}"></i>` +
		`<div class="resolution-message">${resolutionMessage}</div>`;
			
			if (resolutionOverlayType === ResolutionOverlayType.NotSupported) {
				// Aggiungo un pulsante che permette di visualizzare comunque la pagina
				overlayContent += `<button class="btn btn-outline-secondary" id="${this._removeOverlayButtonId}">${Resources.Common.visualizza_comunque}</button>`;
			}
			overlayContent +=
`</div></div>`;

			$(overlayContent).appendTo($('.app-container'));

			if (resolutionOverlayType === ResolutionOverlayType.NotSupported) {
				// Lego l'evento al pulsante di rimozione dell'overlay
				$(`#${this._removeOverlayButtonId}`).on(Seac.Commons.Constants.clickEvent, () => {
					this.removeResolutionOverlay();
				});
			}

			window.scrollTo(0, 0);

			// Blocco lo scroll della pagina nel caso in cui ci sia l'overlay
			$(Seac.Commons.Constants.body).addClass('no-overflow');
		}

		/** Rimuove l'overlay della risoluzione dello schermo */
		public static removeResolutionOverlay(): void {
			$(Seac.Commons.Constants.body).removeClass('no-overflow');
			$(`#${this._removeOverlayButtonId}`).off(Seac.Commons.Constants.clickEvent);
			$(`.${this._resolutionOverlayClass}`).remove();
		}
	}

	export enum ResolutionOverlayType {
		RotateDevice	= 1,
		NotSupported	= 2
	}

	export const pageUtility: PageUtility = new PageUtility();
}
